import { TypeDynamicVideoWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import VideoComponent from './DynamicVideo'

const ContentfulDynamicVideo = withContentful<TypeDynamicVideoWithoutUnresolvableLinksResponse['fields']>(
  VideoComponent,
  {
    title: (props) => props.fields?.title,
    posterImage: (props) => props.fields?.posterImage?.fields?.file?.url,
    alt: (props) => props.fields?.alt,
    showMobileVideo: (props) => props.fields?.showMobileVideo,
    playOnce: (props) => props.fields?.playOnce,
    endFrame: (props) => props.fields?.endFrame,
    videoSources: (props) => {
      return props?.fields?.videoSources
        .filter((source) => source?.fields)
        .map((source) => ({
          source: source.fields?.file?.url,
          contentType: source.fields?.file?.contentType,
        }))
    },
  }
)
export default ContentfulDynamicVideo
